export default __webpack_public_path__ + "static/media/android@2x.d849b020.png";